<template>
  <div class="promo-card banner">
    <div class="promo-card__card bg-white">
      <div class="promo-card__actions">
        <div>
          <a-select :value="selectedLanguage" size="small" @change="handleLangChange" class="lang-select">
            <a-select-option v-for="lang in langOptions" :key="lang.value">
              {{ lang.name }}
            </a-select-option>
          </a-select>
        </div>
        <div>
          <a-button v-if="!isViewscreen" type="link" :disabled="!editPermission" @click="openEditPage"
            class="mr-3"><a-icon type="edit" class="text-primary font-size-16" />Edit</a-button>
          <a-checkbox v-if="isViewscreen" :checked="addToViewscreen" @change="handleViewscreenChange" />
        </div>
      </div>
      <div class="promo-card__content" @click="openFullInfoModal">
        <div class="mb-3">
          <img class="promo-card__image" :src="selectedImage.path" alt="" />
        </div>
        <div class="promo-card__left">
          <div class="mb-2">
            <div class="promo-card--title">Name for internal usage</div>
            <span class="promo-card-title promo-card--text">{{ bannerContext.name }}</span>
          </div>
          <!-- <div class="mb-2">
            <div class="promo-card--title">Section</div>
            <div v-if="Array.isArray(bannerContext.displays) && bannerContext.displays.length"
              style="line-height: 1.8rem">
              <a-tag class="info-modal--tag" v-for="display in bannerContext.displays" :key="display.id">
                {{ displays[display.id] }}
              </a-tag>
            </div>
            <div v-else>-</div>
          </div> -->
          <div class="mb-2">
            <div class="promo-card--title">Apps</div>
            <div style="line-height: 2.1rem">
              <a-tag style="margin-right: 15px; padding: 1px 8px; border-radius: 2px"
                v-for="app in bannerContext.applications.slice(0, 2)" :key="app.id">
                {{ app.name }}
                <a-icon v-if="app.platform.toLowerCase() === 'android'" type="android" class="ml-1 text-success" />
                <a-icon v-if="app.platform.toLowerCase() === 'ios'" type="apple" class="ml-1 text-primary" />
                <a-icon v-if="app.platform.toLowerCase() === 'web'" type="global" class="ml-1 text-default" />
              </a-tag>
              <a-tag v-if="bannerContext.applications.length > 2">
                ...
              </a-tag>
            </div>
          </div>
          <div v-if="bannerContext.periods">
            <div class="promo-card--title">Show Period</div>
            <div style="line-height: 2.1rem">
              <a-tag style="padding: 1px 8px; border-radius: 2px"
                v-for="period in bannerContext.periods.slice(0, 1)" :key="period.starts_at">
                {{ `${formatDate(period.starts_at)} - ${formatDate(period.ends_at)} ${formatTimezone(period.time_mode)}` }}
              </a-tag>
              <a-tag v-if="bannerContext.periods.length > 1" style="padding: 1px 8px; border-radius: 2px">
                {{ `+${bannerContext.periods.length - 1}` }}
              </a-tag>
            </div>
          </div>
        </div>
      </div>
      <div class="promo-card__footer">
        <div class="d-flex align-items-center" :class="{ 'promo-card__footer--inf': !firstPeriodStart }">
          <div class="text-uppercase mr-auto">
            {{ formatDate(firstPeriodStart) }} -
            <span v-if="lastPeriodEnd">{{ formatDate(lastPeriodEnd) }}</span>
            <span v-else style="font-size: 20px;">&infin;</span>
          </div>
          <div class="d-flex">
            <a-switch :default-checked="bannerContext.is_active" @change="bannerActiveSwitch"
              :disabled="!editPermission" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import apiClient from '@/services/axios'
import MediaService from '@/services/api/apiMediaService'

import { formatTimezone } from '@/services/utils/media'

export default {
  name: 'bannerCard',
  props: {
    bannerInfo: {
      type: Object,
    },
    editPermission: {
      type: Boolean,
    },
    languages: {
      type: Array,
    },
    isViewscreen: {
      type: Boolean,
      default: false,
    },
    isMediaChecked: {
      type: Boolean,
      default: false,
    },
    displays: {
      type: Object,
    },
  },
  data: () => ({
    selectedLanguage: 'ru',
    addToViewscreen: false,
  }),
  computed: {
    bannerContext() {
      return this.bannerInfo.context.context
    },
    selectedImage() {
      return this.bannerContext.images[this.selectedLanguage][0]
    },
    langOptions() {
      const langKeys = Object.keys(this.bannerContext.images)
      return this.languages.filter(language => langKeys.includes(language.name)).map(language => ({
        name: language.desc,
        value: language.name,
      }))
    },
    firstPeriodStart() {
      if (!this.bannerContext?.periods?.length) {
        return
      }

      return this.bannerContext.periods[0].starts_at
    },
    lastPeriodEnd() {
      const lastIndex = this.bannerContext.periods?.length - 1

      return this.bannerContext.periods[lastIndex].ends_at
    },
  },
  watch: {
    isMediaChecked(value) {
      this.addToViewscreen = value
    },
  },
  created() {
    if (this.isMediaChecked) {
      this.addToViewscreen = true
    }
    if (this.langOptions.length) {
      this.selectedLanguage = this.langOptions[0].value
    }
  },
  methods: {
    formatTimezone,
    openFullInfoModal() {
      this.$emit('openFullInfo')
    },
    openEditPage() {
      this.$emit('openEdit')
    },
    formatDate: function (date) {
      return this.$moment(date).format('DD.MM.YY HH:mm')
    },
    handleLangChange(selectedLangKey) {
      this.selectedLanguage = selectedLangKey
    },
    handleViewscreenChange(event) {
      this.addToViewscreen = event.target.checked
      const action = event.target.checked ? 'addToMediaArray' : 'deleteFromMediaArray'
      this.$emit(action, this.bannerInfo.id)
    },
    async bannerActiveSwitch(checked) {
      try {
        const bannerPayload = {
          is_active: checked,
        }
        const bannerResponse = await MediaService.updateBanner(this.bannerContext.id, bannerPayload)
        this.$notification.success({
          message: 'Active status changed',
          description: `${this.bannerContext.name} status have been changed`,
        })
        if (bannerResponse?.data?.error || bannerResponse.data.success === false || bannerResponse.data.error) {
          const errorMessage =
          bannerResponse.data.error?.message ||
            'Something went wrong while updating banner activity'
          this.$notification.error({
            message: errorMessage,
          })
          this.loading = false
          return
        }
      } catch (e) {
        const errorMessage =
          e.response.data?.error?.message ||
          'Something went wrong while updating banner activity'
        this.$notification.error({
          message: errorMessage,
        })
      }
    },
  },
}
</script>

<style lang="scss" src="../style.module.scss" />
